import { render, staticRenderFns } from "./SwitchMode.vue?vue&type=template&id=2b9425a8&scoped=true"
import script from "./SwitchMode.vue?vue&type=script&lang=js"
export * from "./SwitchMode.vue?vue&type=script&lang=js"
import style0 from "./SwitchMode.vue?vue&type=style&index=0&id=2b9425a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9425a8",
  null
  
)

export default component.exports